import _ from 'lodash'
import React from 'react'
import { deleteTaxSavingRecord, editTaxSaving, taxSavingExcelExport, taxSavingRecordsExcelExport, taxSavingRecordsExcelReportExport } from '../../../actions/employeeActions'
import { exportExcel } from '../../../common/addExcel'
import { getFinancialYear, isEmpty2 } from '../../../common/utils'
import DropDown from '../../../components/common/dropDownSelect'
import AddTaxSavingModal from '../../../components/modals/addTaxSavingsModal2'
import ApproveReceiptModal from '../../../components/modals/approveReceiptModal'
import DeleteConformModal from '../../../components/modals/deleteConformModal';
import ClickOutside from '../../../components/common/clickOutside';

class Header extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            modalType: '',
            reverseYear: [],
            userId: '',
            item: [],
            userName: '',
            FYear: '',
            sessionYear: '',
            isEdit: false,
            isMoreOptionExport: false,
        }
    }

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen
        })
    }
    toggleMoreOptionsExport = () => {
        this.setState({
            isMoreOptionExport: !this.state.isMoreOptionExport
        });
    };
    refreshData = () => {
        this.props.onRefresh(this.props.employeeId, this.props.financialYear, this.props.selectedFormat);
    }

    approveReceipt = () => {
        this.setState({
            modalType: 'approveModal',
        })
        this.toggle();
    }
    hideMorOptions = () => {
        this.setState({
            isMoreOptionExport: false
        });
    }
    excelExport = () => {
        const taxSavingRecords = this.props.taxSavingRecords;
        const nextYear = `${this.props.financialYear + 1}`.substring(2, 4);
        const headerString = `Tax Savings (FY ${this.props.financialYear}-${nextYear})`;
        if (taxSavingRecords && taxSavingRecords.length > 0) {
            let formattedTaxRecords = taxSavingRecords.map(record => ({ Name: record.FullName, Type: record.TaxSavingTypeName, Category: record.TaxCategoryCode, Date: record.SavingDate, Frequency: record.RecurringFrequencyName, Description: record.AccountNumber, Amount: parseFloat(record.Amount.replace(',', '')), Receipt: record.ItemCount, Remarks: record.Remarks }))
            taxSavingRecordsExcelExport(formattedTaxRecords, headerString)
                .then(res => exportExcel(res))
        }
        // this.hideMorOptions();
    }
    excelReportExport = () => {
        const taxSavingRecords = this.props.taxSavingRecords;
        const nextYear = `${this.props.financialYear + 1}`.substring(2, 4);
        const headerString = `Tax Savings (FY ${this.props.financialYear}-${nextYear})`;
        if (taxSavingRecords && taxSavingRecords.length > 0) {
            let formattedTaxRecords = taxSavingRecords.map(record => ({ Name: record.FullName, Type: record.TaxSavingTypeName, Category: record.TaxCategoryCode, Date: record.SavingDate, Frequency: record.RecurringFrequencyName, Description: record.AccountNumber, Amount: parseFloat(record.Amount.replace(',', '')), Receipt: record.ItemCount, Remarks: record.Remarks }))
            taxSavingRecordsExcelReportExport(formattedTaxRecords, headerString)
                .then(res => exportExcel(res))
        }
        // this.hideMorOptions();
    }
    
    editTaxSavingReceipt = async () => {
        await editTaxSaving({ TaxSavingId: this.props.taxSavingId, EmployeeId: this.props.employeeId, FinancialYear: this.props.financialYear }).then(res => {
            this.setState({
                modalType: 'addModal',
                isEdit: true
            })
        })
        this.toggle();
    }

    deleteTaxSaving = async (taxSavingId) => {
        await deleteTaxSavingRecord(taxSavingId)
        this.refreshData();
        this.toggle()
    }

    addReceipt = () => {
        this.setState({
            //userName: userName,
            FYear: this.props.financialYear,
            userId: this.props.userId,
            item: [],
            modalType: 'addModal',
            isEdit: false
        })
        this.toggle();
    }

    getSelectedFYearText(fYearOptions) {
        const selectedfYear = _.filter(fYearOptions, { value: this.props.financialYear });
        return selectedfYear.length > 0 ? selectedfYear[0].label : '';
    }

    render() {
        const usersData = this.props.employeeData;
        const isAdmin = this.props.isAdmin;
        //const savingDataTable = this.props.employeeData.taxSaving;
        const { selectedFormat } = this.props;
        const employees = usersData.users;
        const employeeId = this.props.employeeId;
        const selectedEmployee = _.filter(employees, { Value: employeeId });
        const employeeName = selectedEmployee && selectedEmployee.length > 0 ? selectedEmployee[0].Text : '';
        const fYearOptions = getFinancialYear();
        const fYearText = this.getSelectedFYearText(fYearOptions);

        return (
            <>
                <div className='row'>
                    <div className="col-md-3">
                        <div className="pull-left" ><h3>Tax Savings</h3></div>
                    </div>
                    <div id="container" className="col-md-9">
                        <div className="float-right">
                            <div className="pull-right">
                                <div className="btn-toolbar" role="toolbar" aria-label="...">
                                    <div className="mgR10" style={{ margin: 5 }}>
                                        <label className="radio-inline mgR10"><input type="radio" name="format" checked={selectedFormat === 'Format1'} value='Format1' onChange={this.props.handleFormatChange} />Data</label>
                                        <label className="radio-inline"><input type="radio" name="format" value='Format2' checked={selectedFormat === 'Format2'} onChange={this.props.handleFormatChange} />Report</label>
                                    </div>

                                    <div>
                                        <DropDown disabled={isAdmin ? false : true} width='200px' showEmptyItem={false} emptyValue={'All'} emptyText='All' selected={employeeId} keyValue="Value" keyText="Text"
                                            onChange={this.props.handleEmployeeChange} options={employees}
                                        />
                                    </div>
                                    <span>&nbsp;&nbsp;</span>
                                    <div>
                                        <DropDown width='100px' showEmptyItem={true} selected={this.props.financialYear} options={fYearOptions}
                                            onChange={this.props.handleFinancialYearChange}
                                        />
                                    </div>

                                    <span>&nbsp;&nbsp;</span>
                                    <div className="btn-group" role="group" aria-label="...">
                                        <ClickOutside onClickOutside={this.hideMorOptions}>
                                            {!isEmpty2(employeeId) &&
                                                <div className="btn-group" role="group" aria-label="...">
                                                    {employeeId === 'All' &&
                                                        <button id="btnAdd" className="btn btn-default ir-btn-neutral-outline disabled" title="Add receipt">
                                                            <i className="fa fa-plus fa-fw"></i>
                                                        </button>
                                                    }
                                                    {employeeId !== 'All' &&
                                                        <button id="btnAdd" className="btn btn-default ir-btn-neutral-outline" onClick={this.addReceipt} title="Add receipt">
                                                            <i className="fa fa-plus fa-fw"></i>
                                                        </button>}
                                                </div>
                                            }

                                            <div className="btn-group" role="group" aria-label="...">
                                                {this.props.taxSavingId == "" ? <button id="btnEdit" disabled className="btn btn-default ir-btn-neutral-outline" onClick={this.editTaxSavingReceipt} data-toggle="tooltip" data-placement="bottom" title="Edit receipt">
                                                    <i className="fa fa-edit fa-fw"></i>
                                                </button> : <button id="btnEdit" className="btn btn-default ir-btn-neutral-outline" onClick={this.editTaxSavingReceipt} data-toggle="tooltip" data-placement="bottom" title="Edit receipt">
                                                        <i className="fa fa-edit fa-fw"></i>
                                                    </button>}
                                            </div>
                                            <div className="btn-group" role="group" aria-label="...">
                                                {this.props.taxSavingId == "" ? <button id="btnDelete" className="btn btn-default ir-btn-neutral-outline" disabled data-toggle="tooltip" data-placement="bottom" title="Delete receipt">
                                                    <i className="fa fa-trash fa-fw"></i>
                                                </button> : <button id="btnDelete" className="btn btn-default ir-btn-neutral-outline" onClick={() => { this.toggle(this.setState({ modalType: "deleteModal" })) }} data-toggle="tooltip" data-placement="bottom" title="Delete receipt">
                                                        <i className="fa fa-trash fa-fw"></i>
                                                    </button>}
                                            </div>
                                            <div className="btn-group" role="group" aria-label="...">

                                                <button id={"btnMoreOptionExportIdeas"}
                                                    className={!this.state.isMoreOptionExport ? 'btn btn-default ir-btn-neutral-outline mgL3' :
                                                        'btn btn-default ir-btn-neutral-outline mgL3'} type="button"
                                                    onClick={this.toggleMoreOptionsExport}>
                                                    <div className="right wd20 center-text">
                                                        <i className={!this.state.isMoreOptionExport ? 'fas fa-chevron-down size-14' : 'fas fa-minus size-14'}></i>
                                                    </div>
                                                </button>
                                            </div>
                                            <ul className="dropdown-menu more-action-ul" style={this.state.isMoreOptionExport ? { display: 'block', left: 1, width: 184, marginTop: 2, paddingBottom: 10 } : { display: 'none' }} >
                                                <li ><a href="#" onClick={this.excelExport} style={{ color: '#566f99' }}>
                                                    <i className="fas fa-file-excel" style={{ paddingRight: 8, color: '#4091ED', lineHeight: '14px' }} ></i>
                                                    <span className='more-action-dropdown-text pdT3' style={{ cursor: 'pointer' }}>
                                                        {('Excel Export')}</span>
                                                </a></li>
                                                <li><a href="#" onClick={this.excelReportExport} style={{ color: '#566f99' }}>
                                                    <i className="fas fa-file-excel" style={{ paddingRight: 8, color: '#4091ED', lineHeight: '14px' }} ></i>
                                                    <span className='more-action-dropdown-text pdT3' style={{ cursor: 'pointer' }}>
                                                        {('Accountant Report')}</span>
                                                </a></li>
                                            </ul>


                                            <div className="btn-group" role="group" aria-label="...">
                                                <button id="btnRefresh" className="btn btn-default ir-btn-neutral-outline" onClick={this.refreshData} data-toggle="tooltip" data-placement="bottom" title="Refresh Data">
                                                    <i className="fas fa-sync-alt"></i>
                                                </button>
                                            </div>
                                        </ClickOutside>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {(this.state.isOpen == true && this.state.modalType == "addModal") &&
                    <AddTaxSavingModal isAdmin={isAdmin} isOpen={this.state.isOpen} toggle={this.toggle.bind(this)}
                        employeeData={this.props.employeeData} fYearText={fYearText} empName={this.props.empName}
                        editTaxSaving={this.state.isEdit ? this.props.editTaxSavingReceipt : []} userName={employeeName} financialYear={this.props.financialYear}
                        userId={this.props.userId} employeeId={employeeId} employeeData={this.props.employeeData} isEdit={this.state.isEdit}
                    />}
                {(this.state.isOpen == true && this.state.modalType == "approveModal") && <ApproveReceiptModal isOpen={this.state.isOpen} toggle={this.toggle.bind(this)} employeeData={this.props.employeeData} refreshData={this.refreshData} />}
                {(this.state.isOpen == true && this.state.modalType == "deleteModal") && <DeleteConformModal isOpen={this.state.isOpen} toggle={this.toggle.bind(this)} conformText={'Are you sure you want to permanently delete this record?'} id={this.props.taxSavingId} onClickEvent={this.deleteTaxSaving} />}
            </>
        )
    }
}

export default Header;
